<template>
  <div class="mayday-main">
    <div class="bg-block">
      <!-- 活动结束横幅（ended 时替代奖励面板） -->
      <div v-if="ended" class="rank-ended-banner">
        <div class="rank-ended-inner">
          <span>{{ $t('lang.ActCommon.k035') }}</span>
        </div>
      </div>

      <!-- 排行奖励说明（活动进行中展示） -->
      <div v-if="!ended" class="rank-reward-panel">
        <div class="rank-reward-grid">
          <div class="rank-reward-cell rank-reward-cell--gold">
            <span class="rank-reward-label">{{ $t('lang.MayDay2026.k006') }}</span>
            <div class="rank-reward-value">
              <span>{{ rankRewards.first }}</span>
              <img class="rank-reward-coin" :src="getMatchImg('coin')" alt="" />
            </div>
          </div>
          <div class="rank-reward-cell rank-reward-cell--silver">
            <span class="rank-reward-label">{{ $t('lang.MayDay2026.k007') }}</span>
            <div class="rank-reward-value">
              <span>{{ rankRewards.second }}</span>
              <img class="rank-reward-coin" :src="getMatchImg('coin')" alt="" />
            </div>
          </div>
          <div class="rank-reward-cell rank-reward-cell--bronze">
            <span class="rank-reward-label">{{ $t('lang.MayDay2026.k008') }}</span>
            <div class="rank-reward-value">
              <span>{{ rankRewards.third }}</span>
              <img class="rank-reward-coin" :src="getMatchImg('coin')" alt="" />
            </div>
          </div>
          <div class="rank-reward-cell rank-reward-cell--rest">
            <span class="rank-reward-label">4-10</span>
            <div class="rank-reward-value">
              <span>{{ rankRewards.fourthToTenth }}</span>
              <img class="rank-reward-coin" :src="getMatchImg('coin')" alt="" />
            </div>
          </div>
        </div>
        <div class="rank-reward-footer">
          <div class="rank-reward-tip-row">
            <span class="rank-reward-tip">{{ $t('lang.MayDay2026.k004') }}</span>
            <button type="button" class="rank-rules-btn" @click="handleToRule">{{ $t('lang.Repurchase.k009') }}</button>
          </div>
        </div>
      </div>

      <!-- 前三名领奖台 -->
      <div class="rank-podium">
        <div class="podium-card podium-card--second">
          <div class="podium-card-inner">
            <img class="podium-avatar podium-avatar--sm" :src="prize2.avatar | imgPath" alt="" />
            <div class="podium-medal podium-medal--sm">
              <img src="./images/n-two.webp" alt="" />
            </div>
            <div class="podium-meta podium-meta--second">
              <span class="podium-name">{{ prize2.nickname || '--' }}</span>
              <div class="podium-score">
                <span>{{ prize2.score != null ? prize2.score : '--' }}</span>
                <img class="podium-pt-ic" src="./images/ic_point.webp" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="podium-card podium-card--first">
          <div class="podium-card-inner">
            <img class="podium-avatar podium-avatar--lg" :src="prize1.avatar | imgPath" alt="" />
            <div class="podium-medal podium-medal--lg">
              <img src="./images/n-one.webp" alt="" />
            </div>
            <div class="podium-meta podium-meta--first">
              <span class="podium-name">{{ prize1.nickname || '--' }}</span>
              <div class="podium-score">
                <span>{{ prize1.score != null ? prize1.score : '--' }}</span>
                <img class="podium-pt-ic" src="./images/ic_point.webp" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="podium-card podium-card--third">
          <div class="podium-card-inner">
            <img class="podium-avatar podium-avatar--sm" :src="prize3.avatar | imgPath" alt="" />
            <div class="podium-medal podium-medal--sm">
              <img src="./images/n-three.webp" alt="" />
            </div>
            <div class="podium-meta podium-meta--third">
              <span class="podium-name">{{ prize3.nickname || '--' }}</span>
              <div class="podium-score">
                <span>{{ prize3.score != null ? prize3.score : '--' }}</span>
                <img class="podium-pt-ic" src="./images/ic_point.webp" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="activity-rank-con">
        <div class="rank-list-shell">
          <div class="rank-list-cap">
            <div class="rank-list-cap-track" />
          </div>

          <div class="rank-body">
            <template v-if="rankList.length > 0">
              <div class="agent-item rank-list-row" v-for="item in rankList" :key="`${item.rank}-${item.uid || item.nickname}`">
                <span class="rank-num">{{ item.rank != null && item.rank !== '' ? item.rank : '--' }}</span>
                <div class="rank-list-user">
                  <img class="rank-list-avatar" :src="item.avatar | imgPath" alt="" />
                  <span class="rank-list-name">{{ item.nickname }}</span>
                </div>
                <div class="rank-list-score">
                  <span class="rank-list-score-val">{{ item.score != null ? item.score : '--' }}</span>
                  <img class="rank-list-score-ic" src="./images/ic_point.webp" alt="" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="agent-item owner-item" v-if="owners" :style="ownerBarStyle">
          <div class="owner-item-content">
            <div class="owner-left">
              <span class="owner-rank-num">{{ ownerRankDisplay }}</span>
              <div class="owner-avatar-wrap">
                <img :src="owners.avatar | imgPath" alt="" />
              </div>
              <div class="owner-text">
                <span class="owner-name">{{ owners.nickname }}</span>
                <MyPLabel v-if="ownerSubLabel" class="owner-sub" :str="ownerSubLabel.str" :numsOption="ownerSubLabel.numsOption" />
              </div>
            </div>
            <div class="owner-right">
              <div class="owner-score-row">
                <span class="owner-score-val">{{ owners.score != null ? owners.score : 0 }}</span>
                <img class="owner-pt-ic" src="./images/ic_point.webp" alt="" />
              </div>
              <button v-if="ownerShowGoEarn" type="button" class="owner-go-earn" @click="handleGoEarn">{{ $t('lang.MayDay2026.k028') }} &gt;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maleSpinLeaderboard } from './apidir/api.js'
import { leaderboardApiToRankPayload } from './utils/maleSpinAdapter.js'

import scrollMixin from '@/hooks/scroll.mixin.js'

export default {
  mixins: [scrollMixin],
  data() {
    return {
      bottomBarHeight: 0,
      title: '',
      ended: false,
      prize1: {},
      prize2: {},
      prize3: {},
      rankList: [],
      owners: {},
      rankRewards: {
        first: 2000,
        second: 1500,
        third: 1000,
        fourthToTenth: 200,
      },
    }
  },
  computed: {
    ownerBarStyle() {
      return { 'margin-bottom': `${this.bottomBarHeight}px` }
    },
    /** 用户 points 分值（< 3 视为未上榜） */
    ownerScore() {
      const s = Number(this.owners && this.owners.score)
      return Number.isFinite(s) ? s : 0
    },
    /**
     * 榜单左侧名次：
     *   score < 3      → '--'（未上榜）
     *   score >= 3, rank > 100  → '100+'
     *   score >= 3, rank <= 100 → 具体名次
     */
    ownerRankDisplay() {
      if (!this.owners) return '--'
      if (this.ownerScore < 3) return '--'
      const r = this.owners.rank
      if (r == null || r === '' || r === '--') return '--'
      const n = Number(r)
      if (!Number.isFinite(n) || n < 1) return '--'
      if (n > 100) return '100+'
      return String(n)
    },
    /**
     * owner 栏副标题：MyPLabel，{n0} ← 接口 gapToNextRank，文案仅 i18n
     * rankStatus === NO_RANKING  → ActCommon.k085
     * rankStatus === IN_TOP_100  → MayDay2026.k002
     * rankStatus === OUTSIDE_TOP_100 → MayDay2026.k003
     */
    ownerSubLabel() {
      if (!this.owners) return null
      const gapRaw = this.owners.gapToNextRank
      let gapNum = null
      if (gapRaw != null && gapRaw !== '') {
        const n = Number(gapRaw)
        gapNum = Number.isFinite(n) ? n : null
      }
      const numsForGap = () => (gapNum != null ? [{ value: String(gapNum) }] : [{ value: '0' }])

      const st = this.owners.rankStatus
      if (st === 'NO_RANKING') {
        return { str: this.$t('lang.ActCommon.k085'), numsOption: [] }
      }
      if (st === 'IN_TOP_100') {
        return { str: this.$t('lang.MayDay2026.k002'), numsOption: numsForGap() }
      }
      if (st === 'OUTSIDE_TOP_100') {
        return { str: this.$t('lang.MayDay2026.k003'), numsOption: numsForGap() }
      }
      return null
    },
    /** score < 3 或排名 > 100 时显示「Go Earn >」按钮；活动结束不显示 */
    ownerShowGoEarn() {
      if (this.ended) return false
      if (!this.owners) return true
      if (this.ownerScore < 3) return true
      const r = this.owners.rank
      if (r == null || r === '' || r === '--') return true
      const n = Number(r)
      if (!Number.isFinite(n) || n < 1) return true
      return n > 100
    },
  },
  methods: {
    handleGoEarn() {
      this.$emit('go-earn')
    },
    handleBack() {
      if (this.$route.query.from === 'mayday2026-main-male') {
        this.goPrevious()
        return
      }
      this.closeWeb()
    },
    // 规则
    handleToRule() {
      const from = this.$route.name === 'mayday2026-main-male' ? 'mayday2026-main-male' : 'mayday2026-rank-male'
      this.$router.push({ path: '/mayday2026-rules-male', query: { from } })
    },
    // 获取数据
    fetchRanking() {
      maleSpinLeaderboard().then((apiData) => {
        const resData = leaderboardApiToRankPayload(apiData)
        if (resData && !resData.error) {
          this.ended = !!resData.ended

          if (resData.ranks && resData.ranks.length > 0) {
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}

            if (this.prize1.rank) {
              this.rankList = resData.ranks && resData.ranks.slice(3)
            } else {
              this.rankList = resData.ranks
            }
          }

          if (resData.owners) {
            this.owners = resData.owners
          }
        }
      })
    },
  },
  created() {
    this.fetchRanking()
  },
  mounted() {
    document.body.scrollTo({ top: 0 })
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.mayday-main {
  position: relative;

  .bg-block {
    position: relative;
    box-sizing: border-box;

    /* 活动结束横幅 */
    .rank-ended-banner {
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px;
      margin-bottom: 12px;

      .rank-ended-inner {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 16px;
        background: #d3f6ff;
        border: 1px solid #fff;
        border-radius: 40px;
        overflow: hidden;

        span {
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 700;
          font-size: 12px;
          line-height: 1.4;
          color: #353a3f;
          text-align: center;
        }
      }
    }

    /* .rank-reward-panel */
    .rank-reward-panel {
      width: 355px;
      max-width: 100%;
      margin: 0 auto 12px;
      padding: 16px 0;
      background: #d3f6ff;
      border: 2px solid #fff;
      border-radius: 20px;
      box-sizing: border-box;

      .rank-reward-grid {
        display: flex;
        gap: 8px;
        padding: 0 16px 16px;
      }

      .rank-reward-cell {
        flex: 1;
        min-width: 0;
        padding: 8px;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        box-sizing: border-box;

        .rank-reward-label {
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 800;
          font-size: 12px;
          text-align: center;
        }

        .rank-reward-value {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2px;
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 800;
          font-size: 14px;
        }

        .rank-reward-coin {
          width: 20px;
          height: 20px;
          object-fit: contain;
        }

        &--gold {
          background: linear-gradient(180deg, #fff3c4 0%, #ffe57d 100%);
          border: 1px solid #fde257;

          .rank-reward-label {
            color: #916000;
          }

          .rank-reward-value {
            color: #d97707;
          }
        }

        &--silver {
          min-height: 54px;
          background: linear-gradient(180deg, #f0f4fa 0%, #e3e8f0 100%);
          border: 1px solid #d9e4f0;

          .rank-reward-label {
            color: #64748b;
          }

          .rank-reward-value {
            color: #324155;
          }
        }

        &--bronze {
          min-height: 54px;
          background: linear-gradient(180deg, #ffe5c8 0%, #fdbf7c 100%);
          border: 1px solid #fdbb74;

          .rank-reward-label {
            color: #9b3412;
          }

          .rank-reward-value {
            color: #c2410d;
          }
        }

        &--rest {
          background: rgba(255, 255, 255, 0.6);
          border: 1px solid #fff;

          .rank-reward-label {
            color: #64748b;
          }

          .rank-reward-value {
            color: #324155;
          }
        }
      }

      .rank-reward-footer {
        padding: 0 16px;

        .rank-reward-tip-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px;
          background: rgba(255, 255, 255, 0.6);
          border: 1px solid #fff;
          border-radius: 40px;
        }

        .rank-reward-tip {
          flex: 1;
          min-width: 0;
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 700;
          font-size: 12px;
          line-height: 1.3;
          color: #353a3f;
        }

        .rank-rules-btn {
          flex-shrink: 0;
          padding: 4px 10px;
          background: #fff;
          border: 1px solid #e3e4e5;
          border-radius: 20px;
          font-family: 'TikTokSans-Regular', sans-serif;
          font-weight: 700;
          font-size: 12px;
          color: #353a3f;
        }
      }
    }

    /* .rank-podium */
    .rank-podium {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      gap: 8px;
      width: 299px;
      max-width: 100%;
      margin: 0 auto 12px;

      .podium-card {
        border-radius: 8px;
        box-sizing: border-box;

        &--second {
          width: 90px;
          background: linear-gradient(180deg, #e1fcff 0%, #eefbff 100%);
          padding: 8px 12px;
        }

        &--first {
          width: 96px;
          background: linear-gradient(180deg, #fef1b8 0%, #f8fcf8 100%);
          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35);
          padding: 8px 12px;
        }

        &--third {
          width: 90px;
          background: linear-gradient(180deg, #fde7d2 0%, #f3f8f9 100%);
          padding: 8px 12px;
        }

        .podium-card-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }

        .podium-avatar {
          border-radius: 50%;
          object-fit: cover;

          &--sm {
            width: 50px;
            height: 50px;
            border: 2px solid rgba(255, 255, 255, 0.9);
          }

          &--lg {
            width: 60px;
            height: 60px;
            border: 2px solid #ffcd55;
          }
        }

        .podium-medal {
          display: flex;
          align-items: center;
          justify-content: center;

          &--sm {
            width: 60px;
            height: 60px;

            img {
              width: 100%;
              height: auto;
              display: block;
            }
          }

          &--lg {
            width: 70px;
            height: 70px;

            img {
              width: 100%;
              height: auto;
              display: block;
            }
          }
        }

        .podium-meta {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          width: 100%;

          .podium-name {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 14px;
            text-align: center;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .podium-score {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 16px;
          }

          .podium-pt-ic {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }

          &--second {
            .podium-name {
              color: #64748b;
            }

            .podium-score {
              color: #324155;
            }
          }

          &--first {
            .podium-name {
              color: #916000;
            }

            .podium-score {
              color: #d97707;
            }
          }

          &--third {
            .podium-name {
              color: #9b3412;
            }

            .podium-score {
              color: #c2410d;
            }
          }
        }
      }
    }

    /* .activity-rank-con */
    .activity-rank-con {
      min-height: 40vh;
      padding-bottom: 96px;

      .rank-list-shell {
        width: 371px;
        max-width: 100%;
        margin: 0 auto;
        position: relative;

        .rank-list-cap {
          height: 36px;
          border-radius: 18px;
          background: rgba(255, 255, 255, 0.8);
          padding: 2px;
          box-sizing: border-box;

          .rank-list-cap-track {
            height: 100%;
            border-radius: 16px;
            background: #d3f6ff;
            border: 0.5px solid #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            &::after {
              content: '';
              width: calc(100% - 14px);
              height: 10px;
              border-radius: 5px;
              background: #7af0f4;
            }
          }
        }

        .rank-body {
          width: 343px;
          margin: -18px auto 0;
          padding: 16px;
          min-height: 250px;
          background: #f9feff;
          border: 1px solid #fff;
          border-radius: 0 0 16px 16px;
          position: relative;
          box-sizing: border-box;

          .tit-time {
            font-family: 'Roboto-Regular', sans-serif;
            font-weight: 400;
            font-size: 15px;
            line-height: 19px;
            color: #333;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          /* 列表行：左名次 | 中头像+昵称 | 右分数+积分图标 */
          .rank-list-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            min-height: 56px;
            padding: 12px 0;
            box-sizing: border-box;

            .rank-num {
              flex-shrink: 0;
              width: 28px;
              min-width: 28px;
              text-align: center;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 800;
              font-size: 16px;
              line-height: 20px;
              color: #64748b;
            }

            .rank-list-user {
              flex: 1;
              min-width: 0;
              display: flex;
              align-items: center;
              gap: 10px;
            }

            .rank-list-avatar {
              flex-shrink: 0;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              object-fit: cover;
            }

            .rank-list-name {
              flex: 1;
              min-width: 0;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 700;
              font-size: 16px;
              line-height: 20px;
              color: #324155;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .rank-list-score {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 4px;
            }

            .rank-list-score-val {
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 700;
              font-size: 18px;
              line-height: 22px;
              color: #324155;
            }

            .rank-list-score-ic {
              width: 28px;
              height: 28px;
              object-fit: contain;
            }
          }
        }
      }

      .owner-item {
        width: 100%;
        max-width: 375px;
        margin: 12px auto 0;
        min-height: 76px;
        position: fixed;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        background: #2a4b56;
        border-radius: 20px 20px 0 0;
        box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.12);
        z-index: 30;

        .owner-item-content {
          padding: 14px 16px 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .owner-left {
          display: flex;
          align-items: center;
          gap: 10px;
          min-width: 0;
          flex: 1;

          .owner-rank-num {
            flex-shrink: 0;
            min-width: 36px;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 17px;
            line-height: 20px;
            color: #fff;
            text-align: left;
          }

          .owner-avatar-wrap {
            flex-shrink: 0;

            img {
              width: 44px;
              height: 44px;
              border-radius: 50%;
              object-fit: cover;
            }
          }

          .owner-text {
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;

            .owner-name {
              font-family: 'TikTokSans-Regular', sans-serif;
              font-weight: 800;
              font-size: 16px;
              line-height: 20px;
              color: #fff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .owner-sub {
              margin: 0;
              font-family: 'TikTokSans-Regular', sans-serif;
              font-size: 12px;
              line-height: 16px;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.65);
            }
          }
        }

        .owner-right {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          gap: 6px;
          flex-shrink: 0;

          .owner-score-row {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 4px;
          }

          .owner-score-val {
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 18px;
            line-height: 22px;
            color: #ffd84d;
          }

          .owner-pt-ic {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }

          .owner-go-earn {
            margin: 0;
            padding: 6px 0 2px;
            min-height: 28px;
            border: none;
            background: transparent;
            appearance: none;
            -webkit-tap-highlight-color: rgba(255, 216, 77, 0.25);
            cursor: pointer;
            font-family: 'TikTokSans-Regular', sans-serif;
            font-weight: 800;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.02em;
            color: #ffd84d;
            text-align: right;
            text-decoration: underline;
            text-underline-offset: 3px;
            text-decoration-thickness: 1px;
            text-decoration-color: rgba(255, 216, 77, 0.75);
            white-space: nowrap;

            &:active {
              opacity: 0.82;
              text-decoration-color: #ffd84d;
            }
          }
        }
      }
    }
  }
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: 'TikTokSans-Regular';
  font-weight: 600;
  color: #ffffff;
}
</style>
